module.exports = __webpack_public_path__ + "static/media/total-conducted-appointments-blue.c896eef7.svg";